import { OPEN_DEVICES_DRAWER, CLOSE_DEVICES_DRAWER } from './action';

const initialState = {
  isOpen: false,
  employeeId: null,
};

const devicesDrawer = (state = initialState, action = {}) => {
  switch (action.type) {
    case OPEN_DEVICES_DRAWER:
      return {
        ...state,
        isOpen: true,
        employeeId: action.payload,
      };

    case CLOSE_DEVICES_DRAWER:
      return {
        ...state,
        isOpen: false,
      };

    default:
      return state;
  }
};

export default devicesDrawer;
